import type { ButtonProps } from '@ingka/button';
import Button from '@ingka/button';
import linkOutIcon from '@ingka/ssr-icon/paths/link-out';
import { useGetRetailUnitQuery } from '@lotta/self-service/lottery-fe/data-access-state';
import { useLocale } from '@lotta/self-service/lottery-fe/feature-hooks';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '@lotta/self-service/lottery-fe/util-config';
import type { Lottery } from '@lotta/shared/types-lottery-schemas';
import { isSignupBasedLottery } from '../../utils/is-signup-based-lottery';
import { getLotterySignupType } from '../../utils/get-lottery-signup-type';

type OpenDemoButtonProps = {
  lottery: Lottery;
  type?: ButtonProps['type'];
  small?: ButtonProps['small'];
  className?: ButtonProps['className'];
};

export const OpenDemoButton: React.FC<OpenDemoButtonProps> = ({ lottery, ...buttonProps }) => {
  const { retailUnit, language } = useLocale();
  const { t } = useTranslation();
  const { ikeaDomain } = useContext(ConfigContext);

  const {
    data: retailUnitData,
    isLoading: retailUnitIsLoading,
    error: retailUnitError,
  } = useGetRetailUnitQuery({ retailUnit });

  if (retailUnitIsLoading || !retailUnitData || retailUnitError) {
    return null;
  }

  // Only show the button if the lottery includes the swipe or simple-signup module
  if (!isSignupBasedLottery(lottery)) {
    return null;
  }

  const demoLanguage = retailUnitData.retailUnit.languages.includes(language)
    ? language
    : retailUnitData.retailUnit.defaultLanguage;

  const signupType = getLotterySignupType(lottery);

  const url = `https://${ikeaDomain}/${retailUnit.toLowerCase()}/${demoLanguage}/ikea-family/contest/sign-up/${signupType}?bypassdate&lotteryId=${encodeURIComponent(
    lottery.id
  )}`;

  return (
    <Button
      {...buttonProps}
      text={`${t('swipe-open-demo-button')}`}
      href={url}
      newWindow={true}
      ssrIcon={linkOutIcon}
      iconPosition="leading"
    />
  );
};
